import { BossDto } from "../hints/BossAutocomplete";
import { LocationDto } from "../locations/LocationDtos";
import ForestSmallKey from "../../core/assets/oot/classic/OoT_Small_Key_Model_Forest.png"
import FireSmallKey from "../../core/assets/oot/classic/OoT_Small_Key_Model_Fire.png"
import WaterSmallKey from "../../core/assets/oot/classic/OoT_Small_Key_Model_Water.png"
import ShadowSmallKey from "../../core/assets/oot/classic/OoT_Small_Key_Model_Shadow.png"
import SpiritSmallKey from "../../core/assets/oot/classic/OoT_Small_Key_Model_Spirit.png"
import BotWSmallKey from "../../core/assets/oot/classic/OoT_Small_Key_Model_Botw.png"
import GTGSmallKey from "../../core/assets/oot/classic/OoT_Small_Key_Model_GTG.png"
import FotressSmallKey from "../../core/assets/oot/classic/OoT_Small_Key_Model_Fortress.png"
import GanonSmallKey from "../../core/assets/oot/classic/OoT_Small_Key_Model_Ganon.png"
import ForestBKey from "../../core/assets/oot/classic/OoT_Boss_Key_Model_Forest.png"
import FireBKey from "../../core/assets/oot/classic/OoT_Boss_Key_Model_Fire.png"
import WaterBKey from "../../core/assets/oot/classic/OoT_Boss_Key_Model_Water.png"
import ShadowBKey from "../../core/assets/oot/classic/OoT_Boss_Key_Model_Shadow.png"
import SpiritBKey from "../../core/assets/oot/classic/OoT_Boss_Key_Model_Spirit.png"
import GanonBKey from "../../core/assets/oot/classic/OoT_Boss_Key_Model_Ganon.png"

export enum DungeonEnum {
    Deku,
    Dc,
    Jabu,
    Forest,
    Fire,
    Water,
    Shadow,
    Spirit,
    Botw,
    Ice,
    Gtg,
    Fortress,
    Ganon
}

export interface DungeonDto {
    id: DungeonEnum
    name: string,
    newPlace: LocationDto | null
    keyMax: number,
    keyMaxMq: number,
    keyObtained: number,
    boss: BossDto | null
    bkObtained: boolean,
    imgSmallKey: string,
    imgBk: string,
    isMq: boolean,
}

export const Dungeons: Array<DungeonDto> = [
    {id: DungeonEnum.Deku, name: "Deku", newPlace: null, keyMax: 0, keyObtained: 0, bkObtained: false, boss: null, imgSmallKey: "", imgBk: "", keyMaxMq: 0, isMq: false},
    {id: DungeonEnum.Dc, name: "DC", newPlace: null, keyMax: 0, keyObtained: 0, bkObtained: false, boss: null, imgSmallKey: "", imgBk: "", keyMaxMq: 0, isMq: false},
    {id: DungeonEnum.Jabu, name: "Jabu", newPlace: null, keyMax: 0, keyObtained: 0, bkObtained: false, boss: null, imgSmallKey: "", imgBk: "", keyMaxMq: 0, isMq: false},
    {id: DungeonEnum.Forest, name: "Forest", newPlace: null, keyMax: 5, keyObtained: 0, bkObtained: false, boss: null, imgSmallKey: ForestSmallKey, imgBk: ForestBKey, keyMaxMq: 6, isMq: false},
    {id: DungeonEnum.Fire, name: "Fire", newPlace: null, keyMax: 8, keyObtained: 0, bkObtained: false, boss: null, imgSmallKey: FireSmallKey, imgBk: FireBKey, keyMaxMq: 5, isMq: false},
    {id: DungeonEnum.Water, name: "Water", newPlace: null, keyMax: 6, keyObtained: 0, bkObtained: false, boss: null, imgSmallKey: WaterSmallKey, imgBk: WaterBKey, keyMaxMq: 2, isMq: false},
    {id: DungeonEnum.Shadow, name: "Shadow", newPlace: null, keyMax: 5, keyObtained: 0, bkObtained: false, boss: null, imgSmallKey: ShadowSmallKey, imgBk: ShadowBKey, keyMaxMq: 6, isMq: false},
    {id: DungeonEnum.Spirit, name: "Spirit", newPlace: null, keyMax: 5, keyObtained: 0, bkObtained: false, boss: null, imgSmallKey: SpiritSmallKey, imgBk: SpiritBKey, keyMaxMq: 7, isMq: false},
    {id: DungeonEnum.Botw, name: "Botw", newPlace: null, keyMax: 3, keyObtained: 0, bkObtained: false, boss: null, imgSmallKey: BotWSmallKey, imgBk: "", keyMaxMq: 2, isMq: false},
    {id: DungeonEnum.Ice, name: "Ice", newPlace: null, keyMax: 0, keyObtained: 0, bkObtained: false, boss: null, imgSmallKey: "", imgBk: "", keyMaxMq: 0, isMq: false},
    {id: DungeonEnum.Gtg, name: "Gtg", newPlace: null, keyMax: 9, keyObtained: 0, bkObtained: false, boss: null, imgSmallKey: GTGSmallKey, imgBk: "", keyMaxMq: 3, isMq: false},
    {id: DungeonEnum.Fortress, name: "Fortress", newPlace: null, keyMax: 4, keyObtained: 0, bkObtained: false, boss: null, imgSmallKey: FotressSmallKey, imgBk: "", keyMaxMq: 4, isMq: false},
    {id: DungeonEnum.Ganon, name: "Ganon", newPlace: null, keyMax: 2, keyObtained: 0, bkObtained: false, boss: null, imgSmallKey: GanonSmallKey, imgBk: GanonBKey, keyMaxMq: 3, isMq: false},
]